import { getWhatsAppUrl } from "../utils/constants";

const DemoButton = () => {
  const handleClick = () => {
    window.open(
      getWhatsAppUrl(
        "Hello! I’m interested in the English Speaking Program. Could you please share more details?",
      ),
      "_blank",
    );
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-secondary-500 hover:bg-secondary-600 text-white px-5 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center gap-2"
      aria-label="Talk with our expert Trainer"
    >
      {/* Calendar icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 5a2 2 0 012-2h2.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-1.272.636a11.042 11.042 0 005.516 5.516l.636-1.272a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        />
      </svg>

      <span className="font-semibold">Talk with our expert Trainer</span>
    </button>
  );
};

export default DemoButton;
